import styled from '@emotion/styled';
import { ClassAttributes, createElement } from 'react';

type Props = ClassAttributes<HTMLElement> & {
  size?: number;
  className?: string;
};

const TwitterIcon = ({ size, className }: Props) => (
  <Root xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width={size} height={size} className={className}>
    <path fill="#1da1f2" d="M0 0h24v24H0z" />
    <path
      d="M9.2 18.1c5.7 0 8.8-4.7 8.8-8.8v-.4c.6-.4 1.1-1 1.5-1.6-.6.2-1.1.4-1.8.5.6-.4 1.1-1 1.4-1.7-.6.4-1.3.6-2 .7-.6-.6-1.4-1-2.2-1-1.7 0-3.1 1.4-3.1 3.1 0 .2 0 .5.1.7-2.6 0-4.8-1.3-6.4-3.1-.2.4-.4 1-.4 1.5 0 1.1.5 2 1.4 2.6-.5 0-1-.2-1.4-.4 0 1.5 1.1 2.7 2.5 3-.3.1-.5.1-.8.1-.2 0-.4 0-.6-.1.4 1.2 1.5 2.1 2.9 2.1-1.1.8-2.4 1.3-3.8 1.3h-.7c1.3 1 2.9 1.5 4.6 1.5"
      fill="#fff"
    />
  </Root>
);

const Root = styled('svg')();

export default TwitterIcon;
